import { render, staticRenderFns } from "./editPhone.vue?vue&type=template&id=42cd7236&scoped=true"
import script from "./editPhone.vue?vue&type=script&lang=js"
export * from "./editPhone.vue?vue&type=script&lang=js"
import style0 from "./editPhone.vue?vue&type=style&index=0&id=42cd7236&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_5qbk3fxidqh42wxgbx7uqb2gxe/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42cd7236",
  null
  
)

export default component.exports